import { Link } from "react-router-dom";
import { SlidersHorizontal, FileSpreadsheet, ChartArea, Repeat, Bike, ClipboardList} from "lucide-react";
import { Action } from "../../components/ui/Action";
import { useMerchant } from "../../store/global/useMerchant";

export function Management() {
  const storeId = useMerchant(st => st.data.merchant.id)
  return (
    <div className="w-full rounded-lg border-zinc-200/30 p-4 shadow-md border gap-4 flex flex-col sm:col-span-2 sm:row-span-4 md:col-span-2 md:row-span-3 lg:col-span-3 lg:row-span-2 xl:col-span-3 xl:row-span-4 bg-white">
      <div className="w-full flex">
        <span className="flex gap-2 text-scale-500 font-semibold text-lg items-center">
          <SlidersHorizontal /> Gestão
        </span>
      </div>
      <div className="w-full flex-wrap flex gap-2 mt-auto [&>div]:w-full [&>div]:w-min-fit [&>div]:flex-1">
        <Action.Root outline asChild className="flex-1 !max-w-full">
          <Link to="/relatorio">
            <Action.Icon icon={FileSpreadsheet} /> Relatórios
          </Link>
        </Action.Root>
        <Action.Root outline asChild className="flex-1 !max-w-full">
          <a href={`https://diagnostico.petlandbrasil.com.br/?s=${storeId}`} target="_blank" rel="noreferrer">
            <Action.Icon icon={ChartArea} /> Diagnostico
          </a>
        </Action.Root>
        <Action.Root outline asChild className="flex-1 !max-w-full">
          <Link to="/relatorio?tab=compras">
            <Action.Icon icon={ChartArea} /> Compras
          </Link>
        </Action.Root>
        <Action.Root outline asChild className="flex-1 !max-w-full">
          <Link to="/assinaturas?tab=assinantes">
            <Action.Icon icon={Repeat} /> Assinantes
          </Link>
        </Action.Root>
        {/*<Action.Root outline asChild className="flex-1 !max-w-full">*/}
        {/*  <Link to="/configuracoes?tab=ifood">*/}
        {/*    <Action.Icon icon={Bike} /> Integração Ifood*/}
        {/*  </Link>*/}
        {/*</Action.Root>*/}
        {/*<Action.Root outline asChild className="flex-1 !max-w-full">*/}
        {/*  <Link to="/configuracoes?tab=services">*/}
        {/*    <Action.Icon icon={ClipboardList} /> Ativação de serviços*/}
        {/*  </Link>*/}
        {/*</Action.Root>*/}
      </div>
    </div >
  );
}




